module.exports = __webpack_public_path__ + "img/behance.213980e9.svg";